import { Accordion, Container, Carousel } from "@peracto/peracto-blocks";
import { default as Embed } from "./Embed";

export default {
    plugins: {
        content: [Accordion, Carousel, Embed],
        layout: [Container],
    },
};
